export default function initEcolutionBentoBox() {
  const sections = document.querySelectorAll(
    ".ecolution-bento-section[data-gallery]"
  );

  sections.forEach((section) => {
    let images;
    try {
      images = JSON.parse(section.dataset.gallery || "[]");
    } catch {
      return;
    }
    if (!Array.isArray(images) || images.length === 0) return;

    const slots = [
      section.querySelector(".ecolution-bento-item--img1"),
      section.querySelector(".ecolution-bento-item--img2"),
      section.querySelector(".ecolution-bento-item--img3"),
    ].filter(Boolean);

    if (slots.length === 0) return;

    const intervalMs = Number(section.dataset.interval) || 5000;
    const transitionMs = Number(section.dataset.transition) || 1500;

    section.classList.add("ecolution-bento-section--js");
    section.style.setProperty("--bento-fade-duration", `${transitionMs}ms`);

    const currentIndices = new Array(slots.length).fill(null);
    let lastSlotIndex = null;

    const urls = images.map((img) => img.src);

    preloadImages(urls).then(() => {
      const initialCount = Math.min(slots.length, images.length);
      const initialIndices = pickDistinctRandomIndices(
        initialCount,
        images.length
      );

      slots.forEach((slot, i) => {
        const idx = initialIndices[i % initialIndices.length];
        currentIndices[i] = idx;
        setSlotImage(slot, images[idx], false);
      });

      window.setInterval(() => {
        rotateOneRandomSlot();
      }, intervalMs);
    });

    function rotateOneRandomSlot() {
      if (images.length < 2) return;

      const slotIndex = pickNextSlotIndex();
      const slot = slots[slotIndex];
      const currentIndex = currentIndices[slotIndex];
      const allIndices = images.map((_, i) => i);

      let candidateIndices = allIndices.filter(
        (i) => !currentIndices.includes(i)
      );

      if (!candidateIndices.length) {
        candidateIndices = allIndices.filter((i) => i !== currentIndex);
      }

      if (!candidateIndices.length) return;

      const nextIndex =
        candidateIndices[Math.floor(Math.random() * candidateIndices.length)];

      currentIndices[slotIndex] = nextIndex;
      setSlotImage(slot, images[nextIndex], true);
      lastSlotIndex = slotIndex;
    }

    function pickNextSlotIndex() {
      if (slots.length === 1 || lastSlotIndex == null) {
        return Math.floor(Math.random() * slots.length);
      }
      let idx;
      do {
        idx = Math.floor(Math.random() * slots.length);
      } while (idx === lastSlotIndex);
      return idx;
    }

    function setSlotImage(slot, image, animate) {
      const baseImg = slot.querySelector("img");
      if (!baseImg) return;

      if (!animate) {
        baseImg.src = image.src;
        baseImg.alt = image.alt || "";
        return;
      }

      const overlay = document.createElement("img");
      overlay.src = image.src;
      overlay.alt = image.alt || "";
      overlay.className = "ecolution-bento-img-overlay";
      slot.appendChild(overlay);

      void overlay.offsetWidth;
      overlay.classList.add("is-visible");

      window.setTimeout(() => {
        baseImg.src = image.src;
        baseImg.alt = image.alt || "";
        if (overlay.parentNode === slot) {
          slot.removeChild(overlay);
        }
      }, transitionMs);
    }

    function preloadImages(urls) {
      return Promise.all(
        urls.map((url) => {
          return new Promise((resolve) => {
            const img = new Image();
            img.onload = img.onerror = resolve;
            img.src = url;
          });
        })
      );
    }

    function pickDistinctRandomIndices(count, max) {
      const indices = Array.from({ length: max }, (_, i) => i);
      for (let i = indices.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = indices[i];
        indices[i] = indices[j];
        indices[j] = tmp;
      }
      return indices.slice(0, count);
    }
  });
}
